import { render, staticRenderFns } from "./MyAsset.vue?vue&type=template&id=f79aea72&scoped=true"
import script from "./MyAsset.vue?vue&type=script&lang=js"
export * from "./MyAsset.vue?vue&type=script&lang=js"
import style0 from "./MyAsset.vue?vue&type=style&index=0&id=f79aea72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79aea72",
  null
  
)

export default component.exports